import { IApiError } from '@/models/apiError.model';
import { IDeliverySettings } from '@/models/deliverySettings.model';

export const SLICE_NAME = 'deliverySettings';

export interface IDeliverySettingsState {
  settings: IDeliverySettings | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: IDeliverySettingsState = {
  settings: null,
  isLoading: false,
  error: null,
};
